// extracted by mini-css-extract-plugin
export var img = "GiftLandingPage-module__img___i3XhJ";